import { concat } from 'lodash';

import RouterParticipants from './router-participants';
import RouterMyTeam from './router-my-team';
import RouterInvitations from './router-invitations';

export default concat(RouterParticipants, RouterMyTeam, RouterInvitations);



// WEBPACK FOOTER //
// ./src/router/professional/persons/index.js